import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { EMAIL_TYPES, PHONE_TYPES } from 'pages/address/address.constant'
import { EmailType, PhoneType } from 'store/company/company.types'
import {
  addContactButtonSx,
  contactAddFieldSx,
} from '../customer-detail-fields'

type ContactAddFormProps = {
  mode: 'email' | 'phone'
  contactName: string
  value: string
  typeValue: EmailType | PhoneType
  onContactNameChange: (value: string) => void
  onValueChange: (value: string) => void
  onTypeChange: (value: EmailType | PhoneType) => void
  onAdd: () => void
  isAdding: boolean
}

const CustomerContactAddForm = ({
  mode,
  contactName,
  value,
  typeValue,
  onContactNameChange,
  onValueChange,
  onTypeChange,
  onAdd,
  isAdding,
}: ContactAddFormProps) => {
  const typeOptions = mode === 'email' ? EMAIL_TYPES : PHONE_TYPES
  const valueLabel = mode === 'email' ? 'Email' : 'Phone Number'
  const canAdd = value.trim().length > 0

  return (
    <Box
      sx={{
        flexShrink: 0,
        px: 3,
        py: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'common.white',
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={1.5}
        alignItems={{ md: 'flex-end' }}
      >
        <Box sx={{ flex: 1, minWidth: 140 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.75 }}>
            Contact Name
          </Typography>
          <TextField
            fullWidth
            size="small"
            value={contactName}
            onChange={(e) => onContactNameChange(e.target.value)}
            sx={contactAddFieldSx}
          />
        </Box>
        <Box sx={{ flex: 1.4, minWidth: 180 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.75 }}>
            {valueLabel}
          </Typography>
          <TextField
            fullWidth
            size="small"
            type={mode === 'email' ? 'email' : 'tel'}
            value={value}
            onChange={(e) => onValueChange(e.target.value)}
            sx={contactAddFieldSx}
          />
        </Box>
        <Box sx={{ minWidth: 160 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.75 }}>
            Type
          </Typography>
          <FormControl fullWidth size="small">
            <InputLabel>Type</InputLabel>
            <Select
              value={typeValue}
              label="Type"
              onChange={(e) =>
                onTypeChange(e.target.value as EmailType | PhoneType)
              }
              sx={contactAddFieldSx}
            >
              {typeOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Button
          variant="contained"
          onClick={onAdd}
          disabled={!canAdd || isAdding}
          sx={addContactButtonSx}
        >
          Add
        </Button>
      </Stack>
    </Box>
  )
}

export default CustomerContactAddForm
